import "./style.scss";
import SidebarCollapse from "../../../app/SidebarCollapse";
import { EditableProps } from "../../editableProps";
import EditableInfo from "@builder/components/editable/EditableInfo";

const Backdrop: React.FC<EditableProps> = ({ parent }: EditableProps) => {
    return (
        <SidebarCollapse title="Product quantity" parent={parent}>
            <EditableInfo
                header="How does it work"
                body="Product quantity is adjusting the amount of products being added to cart for the active selected product"
            />
        </SidebarCollapse>
    );
};

export default Backdrop;
